import { TopToolbar, usePermissions, useTranslate } from 'react-admin';
import CustomToolbarActionsPopover from '@/components/global/buttons/CustomToolbarActionsPopover';
import ColumnsIcon from '@/assets/icons/columns-icon.svg?react';
import { CustomSelectColumnsButton } from '@/components/global/buttons/CustomSelectColumnsButton.jsx';
import CustomCreateButton from '@/components/global/buttons/CustomCreateButton.jsx';
import { SearchFilterInput } from '@/components/global/filters/SearchFilterInput';
import { PeriodFilterInput } from '@/components/global/filters/PeriodFilterInput.jsx';
import ExportResource from '@/components/global/buttons/ExportResource.jsx';
import CustomFilterButton from '@/components/global/filters/CustomFilterButton';
import CachedDataActionButton from '@/components/global/buttons/CachedDataActionButton.jsx';
import { ProductCsvImportButton } from '@/components/product/buttons/ProductCsvImportButton.jsx';

export const ProductListActions = () => {
    const { isLoading, permissions } = usePermissions();
    const translate = useTranslate();

    if (isLoading) return null;

    return (
        <TopToolbar>
            <SearchFilterInput />
            <PeriodFilterInput />
            <CustomFilterButton />
            <CustomSelectColumnsButton startIcon={<ColumnsIcon />} style={{ margin: '0px -4px' }} />
            <CustomToolbarActionsPopover>
                {permissions.isAdmin && <CustomCreateButton label={translate('resources.product.labels.addNewProduct')} />}
                <ExportResource
                    resource='product'
                    format='csv'
                    dataTransformer='products-to-csv-template'
                    label={translate('resources.product.labels.downloadImportTemplate')}
                />
                {permissions.isAdmin && <ProductCsvImportButton />}
                {permissions.isAdmin && <CachedDataActionButton resource='product' type={null} />}
            </CustomToolbarActionsPopover>
        </TopToolbar>
    );
};
